module.exports = __webpack_public_path__ + "static/media/icon-result.532dfcfe.svg";